'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormatter, useNow, useTranslations } from 'next-intl';
import { useCallback } from 'react';
export const useFormatVODTime = () => {
  const $ = _c(4);
  const now = useNow();
  const format = useFormatter();
  const t = useTranslations();
  let t0;
  if ($[0] !== format || $[1] !== now || $[2] !== t) {
    t0 = vodLastUpdateDate => {
      const date = new Date(vodLastUpdateDate);
      const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
      if (diffInSeconds < 60) {
        return t("common.just-now");
      }
      return format.relativeTime(date, now);
    };
    $[0] = format;
    $[1] = now;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const formatVODTime = t0;
  return formatVODTime;
};